// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"aaf00b49","662":"aaf00b49"}[chunkId] + ".chunk.css";
};